import { createFileRoute } from "@tanstack/react-router";

import CreateStaffSidebar from "@/components/Staff/AddStaffSidebar";

export const Route = createFileRoute("/gym/$venueUuid/staff/add")({
  component: CreateStaffSidebar,
});
